import { useSyncExternalStore } from 'react'

import { AccountingTz } from '~/utils/timezone'

export const STORAGE_KEY = 'splits.accountingTimezone'
const SYNC_EVENT = 'splitsAccountingTimezoneChanged'
const DEFAULT_TZ: AccountingTz = 'utc'

const read = (): AccountingTz => {
  if (typeof window === 'undefined') return DEFAULT_TZ
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return stored === 'local' ? 'local' : DEFAULT_TZ
}

const subscribe = (onChange: () => void) => {
  if (typeof window === 'undefined') return () => undefined
  window.addEventListener(SYNC_EVENT, onChange)
  return () => window.removeEventListener(SYNC_EVENT, onChange)
}

const getServerSnapshot = (): AccountingTz => DEFAULT_TZ

const setTz = (value: AccountingTz) => {
  if (typeof window === 'undefined') return
  if (window.localStorage.getItem(STORAGE_KEY) === value) return
  window.localStorage.setItem(STORAGE_KEY, value)
  window.dispatchEvent(new CustomEvent(SYNC_EVENT))
}

export const useAccountingTimezone = (): [
  AccountingTz,
  (value: AccountingTz) => void,
] => {
  const tz = useSyncExternalStore(subscribe, read, getServerSnapshot)
  return [tz, setTz]
}
